export { formatEuro } from "@shared/geld";
export { formatDatum, formatUhrzeit, formatDatumZeit } from "@shared/zeit";

/** „0:12“ seit einem Zeitpunkt. */
export function dauerSeit(iso: string | null, jetzt = Date.now()): string {
  if (!iso) return "0:00";
  const s = Math.max(0, Math.floor((jetzt - new Date(iso).getTime()) / 1000));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
}
